// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","outline":"Button_outline__monpX","children":"Button_children__LNT8R"};